<template>
  <b-tab>
    <template v-slot:title>Settings</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Settings</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_settings == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_settings')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_settings')" />
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">View Company Profile</div>
          <div class="col-2">View Financial Years</div>
          <div class="col-3">View Saving Packages</div> <!-- Added this -->
          <div class="col-3">View Audit Trials</div> <!-- Adjusted col-size to fit -->
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Company Profile -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_company_profile == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_company_profile')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_company_profile')" />
          </div>

          <!-- View Financial Years -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_financial_years == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_financial_years')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_financial_years')" />
          </div>

          <!-- View Saving Packages -->
          <div class="col-3">
            <RockerSwitch v-if="item.view_saving_packages == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_saving_packages')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_saving_packages')" />
          </div>
          
          <!-- View Audit Trials Reports (Adjusted class to col-3) -->
          <div class="col-3">
            <RockerSwitch v-if="item.view_audit_trails == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_audit_trails')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_audit_trails')" />
          </div>

        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "SettingPermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_settings == 1);
    },
  },

  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>